export const CENTER_OFFSET_DESKTOP = 40;

export const CENTER_OFFSET_MOBILE = 80;
